export function readFile(file: File | null): Promise<ArrayBuffer | string | null | undefined> {
    if (!file) return Promise.reject()
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.onload = e => resolve(e.target?.result)
        fileReader.onerror = reject
        fileReader.readAsDataURL(file)
    })
}
